import CampaignInlineSearch from './component';

export default CampaignInlineSearch;
